export const SEARCH_LICENSE_PLATE_NUMBER = (plateNumber, usState) =>
  `license-plate-search?plate=${plateNumber}&state=${usState}&format=json&request_type=web&access_token=57075c6ba628c281b08eedfcd7183792`;
